import { AccountingPeriod, PaymentMethod } from "@/Enums";
import type { PaymentDetails } from "../types";

const createEmptyPaymentDetails = () => {
  return {
    paymentMethod: PaymentMethod.invoice,
    sepaDebitDate: null,
    mandateReference: null,
    invoiceEmail: null,
    debitAccountingPeriod: AccountingPeriod.daily,
    debitPeriodStartDate: null,
    debitLastExportDate: null,
    debitNextExportDate: null,
  } as PaymentDetails;
}

const paymentDetailsHasChangedPaymentMethod = (originalObject: PaymentDetails | undefined | null, changedObject: PaymentDetails | undefined | null) => {
  if(!originalObject || !changedObject){
    return !(!originalObject && !changedObject); // both are empty means no changes
  }

  return changedObject.paymentMethod !== originalObject.paymentMethod;
}

export {
  createEmptyPaymentDetails,
  paymentDetailsHasChangedPaymentMethod
}
